// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container-old":"hero-image__container-old___lxi0M","containerOld":"hero-image__container-old___lxi0M","container":"hero-image__container___3a8Wi","image":"hero-image__image___Qtczj","gradients":"hero-image__gradients___2Xl9A","extended":"hero-image__extended___2JDSO"};
    if(module.hot) {
      // 1745960838023
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  